import React, { useEffect, useState } from "react";
import api, { formatApiError } from "../lib/api";
import { PageHeader, Card, EmptyState, Field } from "../components/ui-ext";
import { Plus, X, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ProjectsPage() {
  const [items, setItems] = useState([]);
  const [show, setShow] = useState(false);

  const load = () => api.get("/projects").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  return (
    <div>
      <PageHeader
        eyebrow="Portfolio"
        title="Projects"
        subtitle="Client engagements — Bharti, VIL, JIO, CIENA and more."
        right={<button onClick={() => setShow(true)} className="bg-[#FF5722] hover:bg-[#F4511E] px-4 py-2 text-sm rounded-sm flex items-center gap-2" data-testid="new-project-btn"><Plus className="w-4 h-4" /> New Project</button>}
      />
      {items.length === 0 ? <EmptyState title="No projects yet" /> : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((p) => (
            <Card key={p.id} className="p-5" testid={`project-${p.id}`}>
              <div className="mono text-[10px] uppercase tracking-widest text-[#FF5722] mb-2">{p.client || "Client"}</div>
              <div className="text-xl font-semibold mb-2">{p.name}</div>
              <div className="text-sm text-slate-400 min-h-[40px]">{p.description || "—"}</div>
            </Card>
          ))}
        </div>
      )}
      {show && <ProjectDialog onClose={() => setShow(false)} onCreated={() => { setShow(false); load(); }} />}
    </div>
  );
}

function ProjectDialog({ onClose, onCreated }) {
  const [form, setForm] = useState({ name: "", client: "", description: "" });
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    if (!form.name.trim()) return toast.error("Enter project name");
    setBusy(true);
    try {
      await api.post("/projects", form);
      toast.success("Project created");
      onCreated();
    } catch (e) { toast.error(formatApiError(e?.response?.data?.detail) || "Failed"); }
    finally { setBusy(false); }
  };
  return (
    <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-4">
      <div className="bg-[#13151A] border border-white/10 w-full max-w-md">
        <div className="px-6 py-4 border-b border-white/10 flex justify-between"><h2 className="text-lg font-semibold">New Project</h2><button onClick={onClose}><X className="w-4 h-4" /></button></div>
        <div className="p-6 space-y-4">
          <Field label="Name"><input className="input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="pj-name" /></Field>
          <Field label="Client"><input className="input" value={form.client} onChange={(e) => setForm({ ...form, client: e.target.value })} data-testid="pj-client" /></Field>
          <Field label="Description"><textarea rows={3} className="input" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} /></Field>
        </div>
        <div className="flex justify-end gap-3 px-6 py-4 border-t border-white/10">
          <button onClick={onClose} className="border border-white/15 px-4 py-2 text-sm rounded-sm">Cancel</button>
          <button onClick={submit} disabled={busy} className="bg-[#FF5722] hover:bg-[#F4511E] px-5 py-2 text-sm rounded-sm flex items-center gap-2" data-testid="pj-submit">{busy && <Loader2 className="w-4 h-4 animate-spin" />} Create</button>
        </div>
        <style>{`.input { width: 100%; background: #0B0C10; border: 1px solid rgba(255,255,255,0.1); padding: 8px 12px; font-size: 13px; border-radius: 2px; color: white; }`}</style>
      </div>
    </div>
  );
}
